/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-08-14 10:44:53
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-08-14 11:58:47
 */

export default  {
  path: 'notice',
  component: () => import(/* webpackChunkName: "company-list" */ '@/pages/system/Notice'),
  meta: {title:'后台公告'}
}